import React, { Fragment, useContext, useRef, useEffect, useState, useLayoutEffect } from "react";
import { NavLink, useHistory, Redirect } from "react-router-dom";
import AdminNavbarLinks from "../Navbars/AdminNavbarLinks.jsx";
import logo from "assets/img/eseal-white.png";
import EsealLogo from 'assets/img/eseal-black.png';
import eSeallogo from 'assets/img/big-logo.png';
import eSealWhiteLogo from 'assets/img/logo.png'
import { PostAPI } from "api/post.js";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { loopBackDomain, loopBackPort } from "environment/environment";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import { LanguageContext } from "context/LanguageContext"
import 'assets/css/custom.css';
import { useSidebar } from "context/SidebarContext.js";
import { NavDropdown } from "react-bootstrap";
import {handleNetworkErrors} from "../../utilities/CommonUtils.js"
import { useTranslation } from 'react-i18next';
import { RedisDataContext } from "context/RedisDataContext";
import Cookies from 'universal-cookie';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; 
const cookies = new Cookies();
let urlhost = window.location.host;
let domain = urlhost.split('.')[0];


const Sidebar = props => {
  const {setHasError} = props;
  const { t } = useTranslation();
  const history = useHistory(); 
  const { expandedSidebar, expandState, handleNavDropDown, isCollapsed, setIsCollapsed, resetSidebarState} = useSidebar();
  const [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  const [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  const [width, setWidth] = useState(window.innerWidth);
  const sidebarFeatures = useContext(RedisDataContext);
  const [tabTitle, setTabTitle] = useState(document.title)
  const language = useContext(LanguageContext);
  const [isSidebarChanged, setIsSidebarChanged] = useState(null)
  const [activeCard, setActiveCard] = useState(null);
  const [hoveredDropdown, setHoveredDropdown] = useState(null);
  const navRef = useRef(null)
  let eSealLogo, eSealStamp ;

  switch(domain) {
    case 'vguard-bt-stg':
      eSealLogo = logo;
      eSealStamp = eSealWhiteLogo;
      break;
    default:
      eSealLogo = EsealLogo;
      eSealStamp = eSeallogo;
      break;
  }
 
  function activeRoute(routeName) {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }

  function updateDimensions() {
    setWidth(window.innerWidth);
  }

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
    props.updateCollapseState(!isCollapsed);
  };

  useEffect(() => {
    if (document.cookie.indexOf('tabTitle') == -1 ) {
      document.title =   tabTitle
    }else{
      document.title = cookies.get('tabTitle')
    }
  },[tabTitle])

  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',
    }
  ]
  
    const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
    const categories =  props.routes 
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)

  useEffect(() => {
    try{
    let urlPath = window.location.pathname;
    categories.forEach(element => {
      if(element.hasOwnProperty('submenuitem')) {
        element.submenuitem.forEach(element => {
        const stringExists = urlPath.includes(element.path);
        if (stringExists) {
          (async () => {
            let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
            const payload = {
              pageTypeID: element.pageTypeId,
              featureID: element.featureId,
              language: currentLanguageCode === 'en' ? 'english' : 'chinese'
            };
            cookies.set('feature_id', element.featureId, { path: '/' });
            cookies.set('pagetype_id', element.pageTypeId, { path: '/' });
            if(isSidebarChanged === false){
              await setGlobalLoadIndicator('1');
              let response = await PostAPI(url, payload);
              handleNetworkErrors(response,setHasError);
              await setFeatureBlueprint(response);
              await setGlobalLoadIndicator('2');
              return; 
            }
            return; 
          })()
        }     
        })
      }
      else {
        let payload;
        if(window.location.pathname == '/admin/dashboard/') {
        (async () => {
          let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
          (domain === 'valvoline') ? 
          payload = {
            pageTypeID: 1,
            featureID: 1
          } :
          payload = {
            pageTypeID: 7,
            featureID: 1,
            language: currentLanguageCode === 'en' ? 'english' : 'chinese'
          }
          cookies.set('feature_id', 1, { path: '/' });
          (domain === 'valvoline') ? cookies.set('pagetype_id', 1, { path: '/' }) :
          cookies.set('pagetype_id', 7, { path: '/' });
          if(isSidebarChanged === false){
            await setGlobalLoadIndicator('1');
            let response = await PostAPI(url, payload);
            handleNetworkErrors(response,setHasError);
            await setFeatureBlueprint(response);
            await setGlobalLoadIndicator('2');
            return;
          }
          return;
        })()
        } 
      }
    })
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }, [window.location.pathname])

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions.bind(this));   
     let urlPath = window.location.pathname;
     categories.forEach((element,key) => {
      if(element.hasOwnProperty('submenuitem')) {
        element.submenuitem.forEach(element => {
      const stringExists = urlPath.includes(element.path);
      if (stringExists) {
        (async () => {
          let featureID = cookies.get('feature_id');
          let pageTypeID = cookies.get('pagetype_id');
          let language = localStorage.getItem('i18nextLng')
          if (featureID && pageTypeID) {
            setGlobalLoadIndicator('1');
            await getFeatureYMLOnLoad(parseInt(pageTypeID), parseInt(featureID), language);
            setGlobalLoadIndicator('2');
          }
        })()
        setActiveCard(key)
      }
    })
  }
    });
  }, [sidebarFeatures]);

  useEffect(() => {
    if (document.cookie.indexOf('tabTitle') == -1 ) {
      document.title =   tabTitle
    }else{
      document.title = cookies.get('tabTitle')
    }
  },[tabTitle])

  async function getFeatureYMLOnLoad(pageTypeID, featureID, language) {
    try{
    if (Object.keys(featureBlueprint).length == 0) {
      let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
      const pageTypeId = {
        pageTypeID: pageTypeID,
        featureID: featureID,
        language : language === 'en' ? 'english' : 'chinese'
      };
      let response = await PostAPI(url, pageTypeId);
      handleNetworkErrors(response,setHasError);
      setFeatureBlueprint(() => {
        return response;
      });
    }
    return true;
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }
  useEffect((e) => {
    document.addEventListener("click", handleOutsideClick, true)
    resetSidebarState()
  } ,[])

  const handleOutsideClick = (e) =>{
    if(navRef.current && !navRef.current.contains(e.target)){
       setActiveCard(null);
    }else{
    }
    
  }

  const handleMouseEnter = (key) => {
    if (isCollapsed) {
      setHoveredDropdown(key);
    }
  };
  
  const handleMouseLeave = () => {
    if (isCollapsed) {
      setHoveredDropdown(null);
    }
  };

  // const activateSidebarFeature = (path) => {
  //   // Find the feature and its index based on the path
  //   const feature = categories.find((prop) => {
  //     return prop.submenuitem && prop.submenuitem.find((subFeature) => subFeature.path === path);
  //   });
  
  //   if (feature) {
  //     // Get the index of the feature in the categories
  //     const featureIndex = categories.indexOf(feature);
  
  //     // Expand the sidebar item
  //     handleNavDropDown(featureIndex);
  
  //     // Navigate to the feature path
  //     history.push(`/admin${path}`);
  //   }
  // };

  const getFeatureYML = async (e, prop) => {
    try{
    let title = tabTitle.split("-")[0]
    setTabTitle(`${title} - ${prop.name}`)
    cookies.set('tabTitle', `${title} - ${prop.name}`, { path: '/' });
    let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
    const payload = {
      pageTypeID: prop.pageTypeId,
      featureID: prop.featureId,
      language: currentLanguageCode === 'en' ? 'english' : 'chinese'
    };
    cookies.set('feature_id', prop.featureId, { path: '/' });
    await setGlobalLoadIndicator('1');
    let response = await PostAPI(url, payload);
    handleNetworkErrors(response,setHasError);
    setIsSidebarChanged(true)
    await setFeatureBlueprint(response);
    await setGlobalLoadIndicator('2');
    return;
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const sidebarBackground = {
    backgroundImage: "url(" + props.image + ")"
  };

  function setChildFeatures(prop) {
    return prop.submenuitem.map((childItem, childKey) => {
    // props.languageYmlExport(language)
      if (childItem.invisible) return null;
      const isExpanded = expandedSidebar.includes(childKey);

      return (
        <li className={`childFeatures ${activeRoute(childItem.layout + childItem.path)}`} key={childKey}>
          <NavLink
            onClick={((child) => {
              props.onNavigate() 
              getFeatureYML(child, childItem)
            })}
            value={childItem.pageTypeId}
            to={childItem.layout + childItem.path}
            className="nav-link"
            activeClassName="active"
          >
            <p >{t(childItem.name)}</p>
          </NavLink>
        </li>
      );
    })
  }

const handleHomeTab = (key) => {
  handleNavDropDown(key)
}

//   const handleNavDropDown = (key) => {
//     const currentExpandedSidebar = expandedSidebar;
//     if(expandedSidebar[expandedSidebar.length-1] !== key){
//       currentExpandedSidebar.pop()
//     }
//     const isSidebarExpanded = currentExpandedSidebar.includes(key);

//     let obj = {};
//     isSidebarExpanded ? (obj[key] = false) :  (obj[key] = true);
//     setExpandState(obj)
    
//     const newExpandedSidebar = isSidebarExpanded
//       ? currentExpandedSidebar.filter((id) => id !== key)
//       : currentExpandedSidebar.concat(key);
//       setExpandedSidebar(newExpandedSidebar);
// }

useEffect(() => {
  if(activeCard !== null){
    handleNavDropDown(activeCard)
  }
}, [activeCard])
  return (
    <Fragment>
     {!(cookies.get('accessToken')) ?
       <Redirect to={{ pathname: "/login" }} />
      : ''}
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="logo-details">
        <a
          style={{ width: '100%' }}
          href="http://eseal.io"
          className=" logo_name"
          rel="noopener noreferrer"
          target="_blank"
        >
            <img className={`logo_img ${isCollapsed ? 'collapsed' : ''}`}src={isCollapsed ?  eSealStamp : eSealLogo} alt="logo_image" />
        </a>
      </div>
      <i className="toggle" onClick={toggleSidebar}>
        {isCollapsed ? <MdOutlineKeyboardArrowRight /> : <MdOutlineKeyboardArrowLeft /> }
      </i>
      <div className={`sidebar-wrapper ${isCollapsed ? 'collapsed' : ''} scrollbar scrollbar-rare-wind`} ref={navRef}>
  <ul className="nav">
    {width <= 991 ? <AdminNavbarLinks /> : null}
    {categories.map((prop, key) => {
      // console.log("@expandedSidebar", expandedSidebar, expandState);
      if (prop.invisible) return null;

      return (
        // Render NavLink if `submenu` is false
        (prop.submenu == false) ? (
          <li className={activeRoute(prop.layout + prop.path)} key={key}>
            <NavLink
              onClick={(e) => {
                getFeatureYML(e, prop);
                handleHomeTab(key);
              }}
              value={prop.pageTypeId}
              to={prop.layout + prop.path}
              className={`nav-link ${(prop.name === "Home" || prop.name === "Production Statistics") && "nav-home"}`}
              activeClassName="active"
            >
              <i>{prop.icon}</i>
              <span>{t(prop.name)}</span>
            </NavLink>
          </li>
        ) : (
          // Render NavDropdown
          <NavDropdown
            open={expandedSidebar.includes(key) && expandState[key] ? true : false}
            eventKey={key}
            className={`custom-nav-dropdown ${isCollapsed ? 'collapsed' : ''}`}
            onClick={(e) => {
              if (isCollapsed ){
                const feature = prop.submenuitem[0];
                getFeatureYML(e, feature);
                history.push(feature.layout + feature.path);
              }
              if(!(expandedSidebar.includes(hoveredDropdown) && expandState[hoveredDropdown])) {
                handleNavDropDown(key);
            }
          }}
            onMouseEnter={() => handleMouseEnter(key)}
            onMouseLeave={handleMouseLeave}
            title={
              isCollapsed ? (
                // Render Tippy when collapsed
                <Tippy
                  interactive={true}
                  appendTo={document.body}
                  placement="right"
                  offset={[0, 20]}
                  arrow={false}
                  animation="shift-toward"
                  theme="custom"
                  content={
                    <ul className="is-hover-menu nav">
                      <div className="menu-header">
                        <p>{t(prop.name)}</p>
                      </div>
                      {prop.submenuitem.map((childItem, childKey) => (
                        <li
                          className={`childFeatures ${activeRoute(childItem.layout + childItem.path)}`}
                          key={childKey}
                        >
                          <NavLink
                            onClick={(e) => {
                              e.stopPropagation();
                              if(!(expandedSidebar.includes(hoveredDropdown) && expandState[hoveredDropdown])) {
                                handleNavDropDown(key);
                            }
                              getFeatureYML(e, childItem)
                            }}
                            value={childItem.pageTypeId}
                            to={childItem.layout + childItem.path}
                            className="nav-link"
                            activeClassName="active"
                          >
                            <p>{childItem.name}</p>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  }
                >
                  <div
                    className={`sidebar-header ${
                      expandedSidebar.includes(key) && expandState[key] ? "sidebar-open" : ""
                    }`}
                  >
                    <i className="icon">{prop.icon}</i>
                  </div>
                </Tippy>
              ) : (
                // Render normal dropdown header when not collapsed
                <div
                  className={`sidebar-header ${
                    expandedSidebar.includes(key) && expandState[key] ? "sidebar-open" : ""
                  }`}
                >
                  <i className="icon">{prop.icon}</i>
                  <span>{t(prop.name)}</span>
                  <i className="pe-7s-angle-down sidebar-chevron" />
                </div>
              )
            }
                  noCaret
                >
                  {setChildFeatures(prop)}
                </NavDropdown>  
        )
            );
          })}
        </ul>
      </div>
    </div>
  </Fragment>
  );
}

export default Sidebar;
